
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ag",
      function () {
        return require("private-next-pages/ag.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ag"])
      });
    }
  